<template>
  <div>
    <v-row no-gutters>
      <v-col class="pa-2" cols="12" lg="4" md="6">
        <v-text-field
          v-model="obj.email"
          append-icon="mdi-at"
          class="rounded-lg"
          clearable
          dense
          label="ایمیل"
          outlined
          type="email"
        />
      </v-col>

      <v-col class="pa-2" cols="12" lg="4" md="6">
        <v-text-field
          v-model="obj.password"
          :append-icon="displayPass ? 'mdi-eye-off-outline' : 'mdi-eye-outline'"
          :type="displayPass ? 'text' : 'password'"
          class="rounded-lg"
          clearable
          dense
          label="پسوورد"
          outlined
          @click:append="displayPass = !displayPass"
        />
      </v-col>

      <v-col class="pa-2" cols="12" lg="4" md="6">
        <v-text-field
          v-model="obj.reqLimit"
          append-icon="mdi-image-auto-adjust"
          class="rounded-lg"
          clearable
          dense
          hide-spin-buttons
          hint="تعداد کل تصاویری که با این نوع توکن میتوان خلق کرد."
          label="تعداد کل تصاویر"
          outlined
          persistent-hint
          type="number"
        />
      </v-col>

      <v-col class="pa-2" cols="12" lg="4" md="6">
        <v-select
          v-model="obj.type"
          :items="typeItems"
          :menu-props="{ offsetY: true }"
          class="rounded-lg"
          clearable
          dense
          label="نوع"
          outlined
        />
      </v-col>

      <v-col class="pa-2" cols="12" lg="8" md="6">
        <v-text-field
          v-model="obj.token"
          append-icon="mdi-text"
          class="rounded-lg"
          clearable
          dense
          label="توکن"
          outlined
        />
      </v-col>
    </v-row>

    <v-card-actions class="justify-end">
      <v-btn
        :loading="loading"
        class="btn-accept rounded-lg ma-0"
        depressed
        min-width="110"
        @click="submit"
      >
        <v-icon left>mdi-content-save-plus</v-icon>
        ثبت
      </v-btn>
    </v-card-actions>
  </div>
</template>

<script>
export default {
  name: "addTogetherToken",

  data: () => ({
    loading: false,
    obj: {
      email: "",
      password: "",
      token: "",
      type: "",
      reqLimit: 370,
    },
    typeItems: [
      {
        value: "togetherAi",
        text: "togetherAi - خلق تصویر",
      },
      {
        value: "openRouter",
        text: "openRouter - چت بات",
      },
    ],
    displayPass: false,
  }),

  methods: {
    submit() {
      if (
        !this.obj.email ||
        !this.obj.password ||
        !this.obj.token ||
        !this.obj.type
      ) {
        this.$toast.warning("لطفا مقادیر را به درستی وارد نمایید!");
        return;
      }

      this.loading = true;

      this.$api
        .post("/v1/testQr/token/store", this.obj)
        .then(({ data }) => {
          this.$toast.success("توکن با موفقیت ثبت شد.");
          this.$emit("fetch");
        })
        .catch(({ response }) => {
          this.$toast.error(response?.data?.message || "خطا در ثبت توکن!");
        })
        .finally(() => (this.loading = false));
    },
  },
};
</script>

<style scoped></style>
